import { TraitRegistryItem } from '../TraitRegistryItem';
export class TraitTypeActor extends TraitRegistryItem {
    constructor(init) {
        super(init);
        Object.assign(this, init);
    }
}
